import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import Tooltip from 'components/Tooltip'

import AssignDeviceModal from 'pages/UnassignedDevice/AssignDeviceModal'
import ArchiveDeviceModal from 'pages/shared/ArchivedDevices/ArchiveDeviceModal'

import Api from 'services/api'

import { color } from 'styles/colors'
import { PageTitle, screenSize } from 'styles/shared'

import { DeviceBase } from 'types/Device'
import { ArchivedDevice } from 'types/ArchivedDevice'

type Props = {
  dealerId: number
  unassignedDevice: DeviceBase
}

const Header = ({ unassignedDevice, dealerId }: Props) => {
  const navigate = useNavigate()

  const [showArchiveSystemModal, setShowArchiveSystemModal] = useState(false)
  const [showAssignToCustomerModal, setShowAssignToCustomerModal] = useState(false)

  const onCreateCallback = async (archivedDevice: Omit<ArchivedDevice, 'id' | 'createdAt'>) => {
    await Api.ArchivedDevices.create(archivedDevice.dealerId, archivedDevice)
      .then(() => {
        navigate('/unassigned_devices')
      })
  }

  return (
    <S.Header>
      <S.DeviceName>
        <PageTitle>{unassignedDevice.name || unassignedDevice.deviceId}</PageTitle>

        <Tooltip title="Archive this device to remove it from the unassigned devices.">
          <S.Archive onClick={() => setShowArchiveSystemModal(true)}>
            <S.ArchiveIcon
              role="img"
              aria-label="archive"
              className="icon-box-add"
            />
            <S.ArchiveLabel>Archive</S.ArchiveLabel>
          </S.Archive>
        </Tooltip>
      </S.DeviceName>

      <Button decoration="positive" text="ASSIGN TO CUSTOMER" icon="new" onPress={() => setShowAssignToCustomerModal(true)} />

      {showArchiveSystemModal && (
        <ArchiveDeviceModal
          isVisible={showArchiveSystemModal}
          auid={unassignedDevice.deviceId}
          onUpdateCallback={(reason) => onCreateCallback({ auid: unassignedDevice.deviceId, dealerId, registered: unassignedDevice.registered, reason })}
          closeCallback={() => setShowArchiveSystemModal(false)}
          actionType="create"
        />)
      }

      {showAssignToCustomerModal && (
        <AssignDeviceModal
          dealerId={dealerId}
          deviceId={unassignedDevice.deviceId}
          closeCallback={() => setShowAssignToCustomerModal(false)}
        />)
      }
    </S.Header>
  )
}

export default Header

const S = {
  Header: styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    @media ${screenSize.small} {
      display: block;
    }
  `,
  DeviceName: styled.div`
    display: flex;

    @media ${screenSize.small} {
      flex-direction: column;
    }
  `,
  Archive: styled.div`
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: ${color('watermarkTitle')};
    margin-left: 35px;

    &:hover {
      color: ${color('ancillaryText')};
      cursor: pointer;
    }

    @media ${screenSize.small} {
      margin: 0px;
    }
  `,
  ArchiveIcon: styled.i`
    color: inherit;
  `,
  ArchiveLabel: styled.span`
    vertical-align: top;
    font-size: 18px;
    font-weight: 700;
    color: inherit;
    margin-left: 10px;
  `
}
